import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const SubsidiariesPage = lazy(() => import('~/features/platform/pages/subsidiaries-page'));

export const Route = createFileRoute('/_authenticated/_tenant/platform/subsidiaries/')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <SubsidiariesPage />
    </Suspense>
  ),
});
